import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogActions, DialogDescription, DialogTitle } from "src/components/base/dialog";
import { Button } from "src/components/base/button";
import { UUID } from "src/api/api_common";
import { ApiInternal } from "src/api/api_internal";

/**
 * The properties for {@link DeleteSubnetDialog}
 */
export type DeleteSubnetDialogProps = {
    /** Callback for closing the popup */
    onClose: () => void;

    /** Callback for successful deletion */
    onDeletion: () => void;

    /** The subnet */
    subnet: {
        /** Name of the subnet */
        name: string;
        /** UUID of the subnet */
        uuid: UUID;
    };
};

/**
 * Dialog to delete a given subnet
 */
export default function DeleteSubnetDialog(props: DeleteSubnetDialogProps) {
    const [t] = useTranslation("dialog-delete-subnet");
    const [tg] = useTranslation();

    /**
     * Delete the subnet
     */
    const deleteSubnet = async () => {
        await ApiInternal.subnets.delete(props.subnet.uuid);
        props.onDeletion();
    };

    return (
        <Dialog open={true} onClose={props.onClose}>
            <DialogTitle>{t("heading.delete-subnet", { subnet: props.subnet.name })}</DialogTitle>
            <DialogDescription>{t("description.delete-subnet")}</DialogDescription>
            <DialogActions>
                <Button onClick={props.onClose}>{tg("button.cancel")}</Button>
                <Button color={"red"} onClick={async () => await deleteSubnet()}>
                    {t("button.delete-subnet")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
